// extracted by mini-css-extract-plugin
export default {"waitingRoomStatusColor":"ogyI0"};